import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissionStore } from '../stores/permissionStore';
import { checkRoutePermission } from '../routes/permission.routes';

interface PermissionRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({ 
  children, 
  fallback 
}) => {
  const location = useLocation();
  const { permissions, isLoading } = usePermissionStore();

  // 如果权限还在加载中，显示加载状态
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        正在加载权限...
      </div>
    );
  }

  // 检查权限
  const hasPermission = checkRoutePermission(location.pathname, permissions);

  if (!hasPermission) {
    if (fallback) {
      return <>{fallback}</>;
    }
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};